<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import Vue from "vue";
import config from "./utils/config.js";
export default {
  name: "App",
  data() {
    return {
      platform: "base"
    };
  },
  mounted() {
    window.sessionStorage.setItem(
      "userConfig",
      JSON.stringify(config(this.platform))
    );
    Vue.http.interceptors.push((request, next) => {
      next(response => {
        if (response.status == 401) {
          this.$router.push("/error");
        }
      });
    });
  }
};
</script>

<style>
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #fdeded;
}
</style>



// WEBPACK FOOTER //
// src/App.vue